import { UserGroupIcon, ArrowRightIcon } from '@heroicons/react/24/outline';

const RoomCard = ({ room, onJoin }) => {
  const { roomId, name, createdBy, participants, maxParticipants, status } = room;
  
  // Calculate how full the room is
  const occupancyPercentage = (participants.length / maxParticipants) * 100;
  
  return (
    <div className="bg-dark-lighter rounded-lg p-6 border border-gray-700 hover:border-gray-500 transition-all">
      <div className="flex justify-between items-start mb-4">
        <h3 className="text-lg font-semibold text-white">{name}</h3>
        <span className="bg-dark-lightest text-gray-300 px-2 py-1 rounded-full text-xs">
          {participants.length}/{maxParticipants} Players
        </span>
      </div>
      
      <p className="text-gray-400 text-sm mb-3">Created by: {createdBy.username}</p>
      
      {/* Progress bar showing room occupancy */}
      <div className="w-full bg-dark-lightest rounded-full h-2 mb-4">
        <div 
          className="bg-blue-500 h-2 rounded-full" 
          style={{ width: `${occupancyPercentage}%` }}
        ></div>
      </div>
      
      <div className="flex justify-between items-center mt-4">
        <div className="flex items-center gap-2">
          <UserGroupIcon className="h-5 w-5 text-blue-400" />
          <span className="text-gray-300 text-sm">
            {participants.length < maxParticipants ? 'Open for players' : 'Room full'}
          </span>
        </div>
        
        <button
          onClick={() => onJoin(roomId)}
          disabled={participants.length >= maxParticipants || status !== 'active'}
          className={`flex items-center gap-1 px-4 py-2 rounded-lg text-sm font-medium ${
            participants.length < maxParticipants && status === 'active'
              ? 'bg-primary hover:bg-primary/90 text-white'
              : 'bg-gray-700 text-gray-400 cursor-not-allowed'
          }`}
        >
          Join Room
          <ArrowRightIcon className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default RoomCard;
